import React from "react";
import Loader from "../components/common/Loader";
import Menu from "../components/home1/Menu";
import Navbar from "../components/home1/Navbar";
import Header from "../components/home1/Header";
import Experience from "../components/home1/Experience";
import Services from "../components/home1/Services";
import Process from "../components/home1/Process";
// import Awards from "../components/home1/Awards";
import Projects from "../components/home1/Projects";
import Testimonials from "../components/home1/Testimonials";
import Team from "../components/home1/Team";
import Blog from "../components/home1/Blog";
import Chat from "../components/home1/Chat";
import Footer from "../components/home1/Footer";
import { Helmet } from "react-helmet";
import {
  SITE_URL,
  SITE_NAME,
  DEFAULT_OG_IMAGE,
} from "../seoConfig";
const PAGE_TITLE =
  SITE_NAME +
  " | Architecture, Interior & Furniture Design Studio";
const PAGE_DESC =
  "SS Architects & Interiors is a full-service design studio offering architecture & exterior design, interior design, custom furniture design, and end-to-end project consultation.";
const PAGE_PATH = "/";
function Home1() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta
          name="description"
          content={PAGE_DESC}
        />
        <link
          rel="canonical"
          href={`${SITE_URL}${PAGE_PATH}`}
        />
        <meta
          property="og:type"
          content="website"
        />
        <meta
          property="og:title"
          content={PAGE_TITLE}
        />
        <meta
          property="og:description"
          content={PAGE_DESC}
        />
        <meta
          property="og:url"
          content={`${SITE_URL}${PAGE_PATH}`}
        />
        <meta
          property="og:image"
          content={`${SITE_URL}${DEFAULT_OG_IMAGE}`}
        />
        <meta
          property="og:site_name"
          content={SITE_NAME}
        />
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content={PAGE_TITLE}
        />
        <meta
          name="twitter:description"
          content={PAGE_DESC}
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/home1/assets/css/home_1_style.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/home1/assets/js/home_1_scripts.js"></script>
      </Helmet>
      <div className="home-style1">
        {/* PRELOADER */}
        <Loader />
        {/* SIDE MENU */}
        <Menu />
        {/* SCROLLSMOOTHER CONTENT WRAPPER — required by home_1_scripts.js */}
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          {/* NAVBAR */}
          <Navbar />
          {/* HEADER */}
          <Header />
          {/* MAIN CONTENT */}
          <main>
            <Experience />
            <Services />
            <Process />
            <Projects />
            <Testimonials />
            {/* <Awards /> */}
            <Team />
            <Blog />
            <Chat />
          </main>
          {/* FOOTER */}
          <Footer />
        </div>
      </div>
    </>
  );
}
export default Home1;